import React from 'react';

import { createRoot } from 'react-dom/client';
import 'aws-amplify/auth/enable-oauth-listener';

import { TalentoTiApp } from './TalentoTiApp';
import './styles/tailwind.css';
import './styles/bases.scss';

const ignoreResizeObserverError = () => {
	const resizeObserverErr =
		'ResizeObserver loop completed with undelivered notifications';
	window.addEventListener('error', (e) => {
		if (e.message === resizeObserverErr) {
			e.stopImmediatePropagation();
		}
	});
};

ignoreResizeObserverError();

const container = document.getElementById('root');

if (!container) {
	throw new Error(
		'No se encontro el elemento root para inicializar la aplicacion',
	);
}

const root = createRoot(container);

root.render(
	<React.StrictMode>
		<TalentoTiApp />
	</React.StrictMode>,
);
